import { createFileRoute } from '@tanstack/react-router'
import TransferStockScreen from './-components'
import { pharmacyClient } from '@/connect'
import dayjs from 'dayjs'
import { PharmacySize } from '@/gen/auth/common_pb'
import { Branch, StockPoint } from '@/gen/branch/common_pb'

export const Route = createFileRoute('/(pharma)/_layout/inventory/transfer-stock/')({
  component: TransferStockScreen,
  loader: async () => {
    const pharmacySize = localStorage.getItem('pharmacySize')

    let stockPoints: StockPoint[] = []
    let branches: Branch[] = []

    if (pharmacySize === PharmacySize.SIZE_SMALL.toString()) {
      const branchesRes = await pharmacyClient.getBranchesForCompany({})
      branches = branchesRes.branches
    } else {
      const stockPointsRes = await pharmacyClient.getStockPoints({
        startDate: dayjs().subtract(30, 'day').unix(),
        endDate: dayjs().unix(),
      })
      stockPoints = stockPointsRes.stockPoints
    }

    return {
      stockPoints: stockPoints,
      branches: branches,
    }
  }
})